module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm2"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/prologue.jpg",
      "width": "72%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Dust tickled the side of Kettle’s nose, but he did not bother to scratch it. The torchlit outline of Castle Avërand loomed ahead in the moonless night, like a candle against the stars. He cared little for the grand edifice that stood over Hillshaven, but he traveled toward it anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What lay within its walls was far more important.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s been a long time. Not much farther now")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kettle strolled down the wide country road, carrying a small knapsack over his shoulder, a dim lantern in one hand, and a short walking stick in the other. The weight on his shoulder was light but tiresome. Beads of sweat formed on his brow, appropriate for the warm summer night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Torches lined the granite walls that surrounded the city, revealing moss and thick ivies on the old stones. The smell of fresh dew enveloped Kettle’s senses and the trickling of a small brook met his ears, followed by the sight of a bridge. Making his way over the water, he saw a shadow move alongside the base of the southern tower. Kettle smothered his light, crept into the grasses, and peeked through the blades, hoping to catch another glimpse of the shadow before he approached. He waited and watched as torchlight illuminated the figure. It was a young maiden with long golden hair, dressed in a fine summer gown.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What’s a pretty thing like her doing out in the middle of the night?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She made her way to the front gate, looking around cautiously. A guard stood from his chair as she neared. “Feeling better, Your Highness?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The maiden shook her head. “These insects are awfully loud tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s no moon. How else will they find each other?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Open the door — and speak of my leaving to no one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man frowned as he let her pass and then he locked the door behind her. Intrigued, Kettle reached out his hand to grasp the maiden’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("thread")]), _vm._v(". The girl had a strong will, and noble blood flowed through her veins, just like his old friend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Could it be?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes. He had no doubt. She was the daughter of his friend, the prince. When he had seen her last, she was nothing more than a babe in a bundle of cloth. Not anymore. She had grown into a striking young woman, a maiden of virtue and fair beauty, as Kettle would have expected from the prince’s bloodline. He would surely see her soon enough, but, for now, he had to introduce himself at the gate and make his way inside. Kettle emerged from the grass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who’s there?” said the gatekeeper. “What do you want?’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am a lone traveler,” Kettle answered. “No one of consequence.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s much too late to be traveling alone, old man. What do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A night’s lodging within your walls, if you would accommodate?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re too late to lodge here, stranger. Try the inn at Boarshovel, just down the road.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kettle pressed his back against the wall. “I have come from Harvestport and would rather not retrace my steps. I will wait here, if you don’t mind. I have business inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You carry a light load for business …”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smiling, Kettle lowered his knapsack and lantern.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The gatekeeper grunted as he sat down in his chair. “You’ll have to move along.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Would you like some company? I would imagine your job must be quite dull.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dull? Ha! Frightfully so …” The gatekeeper sighed and then smiled. “Fine — I suppose you can stay. Just don’t try anything. I may not be young anymore, but I can still take you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kettle chuckled. “So it would appear.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s your name then, stranger?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You may call me Kettle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This made the man laugh. “Like Kettlescreek, north of here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why, yes,” he said, joining in the laughter. “Just like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Curious name for an old goat — mine’s Dyre.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kettle smiled without allowing the remark to insult him. The gatekeeper had judged him only by what he could see. “Thank you for allowing me to rest here. It will give me a chance to study you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dyre raised his brow. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Study")]), _vm._v(" me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am an artist, my good man. Inspiration comes best while I watch people. I study their faces, observe the way they move and speak. Every subtle difference fascinates me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dyre rocked his chair back. “I’d rather not have you stare at me all night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you would prefer conversation, there is much I would like to know. It’s been years since I last visited Avërand. Your crops are the healthiest I’ve seen since my youth.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I could oblige that. What would you like to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That maiden who entered the gate — who is she?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man hesitated. “Oh, um … I’m afraid I can’t talk about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kettle dabbed his finger into a pocket within his sleeve and secretly flicked a drop of blue dye at the gatekeeper. It landed on the man’s hand, unnoticed, and seeped into his skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That should do the trick.")]), _vm._v(" “You can tell me; I will not say a word.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s King Lennart’s daughter,” the man said without hesitation. His voice, throat, mind, and body had completely relaxed. Blue dye: subtle, yet effective. “She’s not allowed outside this late, but it makes her happy, mostly. I’m not supposed to tell anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course, and neither will I. Prince Lennart has assumed the throne, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not that he does much with it — he hasn’t done much of anything since his father was murdered.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kettle nodded his sympathies. “Yalva. I knew him well. Such a tragedy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Indeed, it was.” Dyre coughed. “We don’t like to talk of it, even though it happened ages ago — rumors and such. Some say a wizard killed him, if you believe such nonsense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right,” Kettle agreed. “Utter nonsense.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The gatekeeper cleared his throat. “What else would you like to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Much.” Kettle had a long list of questions with hours left before dawn. He decided to save his more delicate questions for later. “What is it like to be the gatekeeper here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dyre beamed. “Easy, with plenty of perks, the best being this sweet scullery maid who brings me cherry tarts — they’re my favorite!” The man leaned forward and stretched his legs. “I manage the outs and ins from here; three night watches and four day watches a week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kettle looked at the wooden lever beside Dyre’s chair as the gatekeeper succinctly laid out his occupation. All of this was good to know. “Why do you sit out here and not inside the gate?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The night air is peaceful,” the man said. “I’ve had no problem at this post for years. And besides, the most I would have to do is pull this lever if danger should ever come this way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I take it you’ve seen "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("everyone")]), _vm._v(" who comes and goes this way?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dyre laughed. “I’ve seen every last soul in Avërand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then you know Lady Katharina and her boy, Lief?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The gatekeeper furrowed his brow. “I haven’t heard their names in years.” Dyre sat up, placing his hands on his knees. “How do you know of them?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I knew them long ago,” Kettle said. “Are they no longer among the nobility?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They vanished from the castle shortly after King Yalva’s death.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kettle’s smile thinned and then faded. “Do they remain in this land?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dyre frowned as he shook his head. “How should I know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This news made Kettle clench his teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The boy can’t be gone. He has to be here! She wouldn’t leave …")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All had gone according to plan, but now he would have to improvise.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Will he come for the princess?” Kettle asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come for … "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("who")]), _vm._v("?” The gatekeeper rubbed his eyes. The dye had worn off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Since Kettle’s business no longer resided in the castle, he would have to look elsewhere for the boy; but where else would he be? He had to find him. Kettle’s return to Avërand would be pointless otherwise. He reached out his hand to grasp the boy’s thread, to sense his presence in the land … but he felt nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("If I am to find him, I must stay close to the princess …")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had no other choice. Kettle focused his eyes on the gatekeeper and studied him. Chin, cheeks, forehead, then ears, eyes, nose. In seconds, Kettle memorized Dyre’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The gatekeeper squinted as he raised his hand for the lever. “Who are you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Instantly, Kettle pushed off the wall and shoved Dyre away from the lever. He then covered the gatekeeper’s mouth with one hand, brandished a knife in the other, and grazed its fine edge along the man’s throat. Dyre’s eyes widened as Kettle’s face unraveled and coiled in the air like a spool of fleshy thread — and wove back as a mirror image of the gatekeeper himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“For now,” he said, using Dyre’s voice, “I will be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(".”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38af7153","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545756211_fm002.vue
// module id = 69
// module chunks = 0